import { render } from "./BaseModalButtonWrapper.vue?vue&type=template&id=d62e25f2"
import script from "./BaseModalButtonWrapper.vue?vue&type=script&lang=js"
export * from "./BaseModalButtonWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__